function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6665 12.6667V7.33332H15.3332V12.6667H20.6665V15.3333H15.3332V20.6667H12.6665V15.3333H7.33317V12.6667H12.6665ZM13.9998 27.3333C6.63584 27.3333 0.666504 21.364 0.666504 14C0.666504 6.63599 6.63584 0.666656 13.9998 0.666656C21.3638 0.666656 27.3332 6.63599 27.3332 14C27.3332 21.364 21.3638 27.3333 13.9998 27.3333ZM13.9998 24.6667C16.8288 24.6667 19.5419 23.5429 21.5423 21.5425C23.5427 19.5421 24.6665 16.829 24.6665 14C24.6665 11.171 23.5427 8.45791 21.5423 6.45752C19.5419 4.45713 16.8288 3.33332 13.9998 3.33332C11.1709 3.33332 8.45775 4.45713 6.45737 6.45752C4.45698 8.45791 3.33317 11.171 3.33317 14C3.33317 16.829 4.45698 19.5421 6.45737 21.5425C8.45775 23.5429 11.1709 24.6667 13.9998 24.6667Z",
  fill: "white"
});

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.defd60678d25146f15ef7bc0bc25516a.svg";
export { ForwardRef as ReactComponent };